// Polyfill
import 'intersection-observer';

const LazyLoad = {
  init() {
    // Sets the intersection area 300px top and bottom of viewport so that images are loaded before
    // they are in view. We want to hide the lazy load process from the user as much as possible.
    const options = {
      root: null,
      rootMargin: "300px 0px 300px 0px",
      threshold: 0
    };

    const callbackFn = (entries) => {
      entries.forEach(entry => {
        if ( entry.isIntersecting || entry.intersectionRatio > 0 ) {
          LazyLoad.loadImage(entry.target);

          // Stops observing (frees up resources)
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callbackFn, options);

    // Adds lazy load observer to all images which have not yet been loaded
    document.querySelectorAll('[data-lazy-full]').forEach(node => {
      observer.observe(node);
    });
  },

  revealImage(img) {
    img.closest('[data-lazy]').dataset.lazy = 1;
  },

  loadImage(img) {
    // Sets image src, making it load
    img.src = img.dataset.lazyFull;
    // Image loaded, attribute no longer required
    img.removeAttribute('data-lazy-full');

    // Loading complete, show image
    if ( img.complete && img.naturalHeight !== 0 ) {
      this.revealImage(img);
    }

    // Adds event so that image is shown once it's loaded
    else {
      img.addEventListener('load', ({ target }) => {
        LazyLoad.revealImage(target);
      });
    }
  }
};

export default LazyLoad;